module.exports = __webpack_public_path__ + "static/media/commandeenligne-pay+.ce9a2ad8.png";